<template>
  <section class="w-full py-8 px-12 lg:px-20 mb-component">
    <div
      class="pt-8 w-full bg-soft-gold-teal shadow-[0px_0px_16px_0px_rgba(73,153,142,0.25)] border border-transparentGreen"
    >
      <div class="w-full px-8 mb-8">
        <h2
          v-if="parsedDictionary.heading"
          class="text-darkGreen max-md:leading-[3rem] tracking-tightest2 text-40 font-medium"
        >
          {{ parsedDictionary.heading }}
        </h2>
        <p
          v-if="parsedDictionary.subheading"
          class="font-normal mt-2 text-18 text-darkGreen leading-140 tracking-tightest2"
        >
          {{ parsedDictionary.subheading }}
        </p>

        <a
          v-if="buttonLink"
          :href="buttonLink"
          class="primary-button mt-4 w-fit"
        >
          <span v-if="parsedDictionary.button">{{
            parsedDictionary.button
          }}</span>
          <ArrowRight />
        </a>
      </div>

      <div
        v-if="parsedDictionary.advantages?.length > 0"
        class="grid w-full grid-cols-1 md:grid-cols-3"
      >
        <div
          v-for="(advantage, index) in parsedDictionary.advantages"
          :key="index"
          class="border-t border-border flex flex-col gap-3 w-full px-8 py-6"
          :class="{
            'border-r': index !== parsedDictionary.advantages.length - 1,
          }"
        >
          <component :is="advertisementIcons[index]" class="text-darkGreen" />
          <h3
            class="text-darkGreen tracking-tightest2 text-20 font-medium leading-135"
          >
            {{ advantage.title }}
          </h3>
          <p
            class="font-normal text-16 text-transparentGreen tracking-tightest3 leading-140"
          >
            {{ advantage.description }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ArrowRight from "../../../svg/ArrowRight.vue";
import { advertisementIcons } from "./shared";

export default {
  name: "Advertisement",
  components: {
    ArrowRight,
  },
  data() {
    return {
      advertisementIcons,
    };
  },

  props: {
    dictionary: {
      type: String,
      required: true,
    },
    buttonLink: {
      type: String,
      required: true,
    },
  },

  computed: {
    parsedDictionary() {
      if (this.dictionary) return JSON.parse(this.dictionary);

      return {};
    },
  },
};
</script>
